import * as React from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { Map, Viewport } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import { GoogleTileLayer } from './';

interface Props {
  className?: string;
  leafletRef?: (map: L.Map) => void;
  keyboard?: boolean;
  viewport?: Viewport | null;
}

interface State {
  defaultViewport: Viewport | null;
  customViewport: Viewport | null;
}

const FALLBACK_VIEWPORT: Viewport = {
  center: [-37.280609, -59.648724],
  zoom: 14
};

class BaseMap extends React.Component<Props, State> {
  private mapRef: L.Map;

  public static getDerivedStateFromProps(nextProps: Props, prevState: State): State {
    const { viewport } = nextProps;
    const { defaultViewport, customViewport } = prevState;

    return {
      defaultViewport: viewport || null,
      customViewport:
        viewport &&
        defaultViewport &&
        viewport.center !== defaultViewport.center
          ? viewport
          : customViewport
    };
  }

  constructor(props: Props) {
    super(props);
    this.state = {
      customViewport: null,
      defaultViewport: null
    };
  }

  handleRef = (map: Map | null) => {
    const { leafletRef } = this.props;

    if (!map) {
      return;
    }

    this.mapRef = map.leafletElement;

    if (leafletRef) {
      leafletRef(map.leafletElement);
    }
  };

  handleViewportChanged = async (viewport: Viewport) => {
    await this.setState({ customViewport: viewport });
  };

  handleResize = () => {
    if (!this.mapRef) {
      return;
    }

    this.mapRef.invalidateSize();
  };

  render() {
    const { children, leafletRef, keyboard, ...other } = this.props;

    const { customViewport, defaultViewport } = this.state;

    const viewport = customViewport || defaultViewport || FALLBACK_VIEWPORT;

    return (
      <Map
        {...other}
        keyboard={keyboard}
        viewport={viewport}
        ref={this.handleRef}
        onViewportChanged={this.handleViewportChanged}
      >
        <GoogleTileLayer />
        {children}
        <ReactResizeDetector
          handleWidth={true}
          handleHeight={true}
          onResize={this.handleResize}
        />
      </Map>
    );
  }
}

export default BaseMap;



// WEBPACK FOOTER //
// ./src/components/BaseMap.tsx